import {
  FaBookOpenReader,
  FaBookQuran,
  FaLanguage,
  FaMicrophoneLines,
  FaMosque,
  FaScroll,
} from 'react-icons/fa6'

export const SERVICES_CONTENT = {
  eyebrow: 'WHAT WE OFFER',
  title: 'We Offer An Effective Arabic & Quran Services',
  actionLabel: 'Explore Courses',
}

export const SERVICES = [
  {
    title: 'Quran for Kids',
    description:
      'Engaging Quran lessons designed for children, combining memorization, recitation, Islamic values, and an enjoyable learning experience.',
    icon: FaBookQuran,
    index: '01',
  },
  {
    title: 'Tajweed & Recitation',
    description:
      'Learn the rules of Tajweed and improve your pronunciation, fluency, and confidence through personalized guidance and practical recitation.',
    icon: FaMicrophoneLines,
    index: '02',
  },
  {
    title: 'Noorani Qaida',
    description:
      'Build a strong foundation in Quran reading through the Noorani Qaida method. Students learn Arabic letters, correct pronunciation, vowels, joining letters, and essential reading rules step by step before progressing to the Quran.',
    icon: FaBookOpenReader,
    index: '06',
  },

  {
    title: 'Arabic for Kids',
    description:
      'Fun and engaging Arabic lessons designed for children, helping them build essential language skills through age-appropriate activities, reading, vocabulary, and conversation.',
    icon: FaLanguage,
    index: '05',
  },
  {
    title: 'Islamic Studies',
    description:
      'Explore essential Islamic knowledge through age-appropriate lessons covering faith, worship, manners, stories of the Prophets, and Islamic values.',
    icon: FaMosque,
    index: '03',
  },
  {
    title: "Quranic Qira'at",
    description:
      'Learn the authentic recitations of the Quran with qualified teachers and discover the unique characteristics and beauty of each Qira’ah.',
    icon: FaScroll,
    index: '07',
  },
]
